import { createSelector } from "reselect"
import { chain, get, find } from "lodash"

const EMPTY_ARRAY = []
const getContentSets = state => get(state, "global.data.contentSets.data.contentSets", EMPTY_ARRAY)
const getContentSetId = (_, props) => props.contentSet

const getContentSet = createSelector(
  [getContentSets, getContentSetId],
  (contentSets, contentSetId) => find(contentSets, ({ id }) => id === contentSetId),
)

export const getCategories = createSelector(
  [getContentSet],
  (contentSet) => get(contentSet, "categories"),
)

export const getFactorsMap = createSelector(
  [getContentSet],
  (contentSet) => chain(contentSet)
    .get("factors")
    .keyBy("id")
    .value(),
)
